import { gql } from 'graphql.macro';
import { messagesFragment, chatMessageFragment } from 'apollo/fragments';

export const createMessageTemplate = gql`
    mutation createMessage($messageInput: MessageInput!) {
        createMessage(messageInput: $messageInput) {
            ...messagesFields
        }
    }
    ${messagesFragment}
`;

export const sendChatMessageTemplate = gql`
    mutation sendChatMessage($orderId: MongoDbObjectId!, $message: String!) {
        sendChatMessage(orderId: $orderId, message: $message) {
            ...chatMessage
        }
    }
    ${chatMessageFragment}
`;

export const markChatMessageAsReadTemplate = gql`
    mutation markChatMessageAsRead($orderId: MongoDbObjectId!) {
        markChatMessageAsRead(orderId: $orderId)
    }
`;
